import { Text, TextTitle } from "./Texts";

import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const TextSubscript = ({
  className,
  valueText,
  subscriptText,
  valueSize,
  subscriptSize,
  valueColor,
  subscriptColor,
  align,
  regular,
}) => {
  return (
    <StyledContainer className={className} align={align}>
      {typeof valueText === "object" ? (
        valueText
      ) : regular ? (
        <Text size={valueSize} color={valueColor}>
          {valueText}
        </Text>
      ) : (
        <TextTitle size={valueSize} color={valueColor}>
          {valueText}
        </TextTitle>
      )}
      {subscriptText && (
        <StyledTextUnit size={subscriptSize || "12px"} color={subscriptColor}>
          {subscriptText}
        </StyledTextUnit>
      )}
    </StyledContainer>
  );
};

TextSubscript.propTypes = {
  className: PropTypes.string,
  valueText: PropTypes.any,
  subscriptText: PropTypes.string,
  valueSize: PropTypes.string,
  subscriptSize: PropTypes.string,
  valueColor: PropTypes.string,
  subscriptColor: PropTypes.string,
  align: PropTypes.string,
};

export default TextSubscript;

const StyledContainer = styled.div.attrs((props) => ({
  align: props.align === "right" ? "flex-end" : props.align,
}))`
  display: flex;
  flex-direction: row;
  line-height: normal;
  justify-content: ${(props) => props.align};
  align-items: baseline;
  line-height: 1;
`;

const StyledTextUnit = styled(Text)`
  margin: 0 0 0 4px;
`;
